
export const DEFAULT_CONTACT_ROUTES = [
  {
    name: 'Profile',
    path: 'overview',
    type: 'both',
  },
  {
    name: 'Studies',
    path: 'studies',
    type: 'external',
  },
  {
    name: 'Sites',
    path: 'sites',
    type: 'external',
  },
];
